<form [formGroup]="form" class="request-form">
  <div class="form-row resources-columns">
    <!-- Left column: Requested Resources (how many people of each seniority) -->
    <div class="resources-column">
      <label class="field-label">
        Requested Resources by Seniority
        <span class="resource-count">({{ requestedTotal }} total)</span>
        <mat-icon
          class="label-help-icon"
          matTooltip="Specify how many resources you need at each seniority level. Choose &quot;Any&quot; if seniority does not matter."
          matTooltipPosition="above"
        >
          help
        </mat-icon>
      </label>

      <app-requested-resources-editor
        [rows]="requestedResources"
        (rowsChange)="onRequestedRowsChange($event)"
      ></app-requested-resources-editor>
    </div>

    <!-- Right column: Preferred Resources -->
    <div class="form-field-wrapper preferred-column">
      <label class="field-label">
        Preferred Resources
        @if (preferred.length > 0) {
          <span class="resource-count">({{ preferred.length }})</span>
        }
        <mat-icon
          class="label-help-icon"
          matTooltip="Provide one or more resources that you would prefer to work with, if they are available. The staffing manager will make the final assignment."
          matTooltipPosition="above"
        >
          help
        </mat-icon>
      </label>

      <div class="preferred-field-wrapper">
        <mat-form-field appearance="outline" class="preferred-search-field">
          <mat-icon matPrefix>search</mat-icon>
          <input
            matInput
            formControlName="preferredSearch"
            placeholder="Search resources to add..."
            autocomplete="off"
            (input)="onPreferredInput($event)"
            (blur)="onPreferredBlur()"
          />
          @if (isLoadingPreferred) {
            <mat-spinner
              matSuffix
              diameter="16"
              class="field-spinner"
            ></mat-spinner>
          }
        </mat-form-field>

        @if (preferredSuggestions.length > 0) {
          <div class="preferred-suggestions">
            <div class="preferred-suggestions-scroll">
              @for (r of preferredSuggestions; track r.resource.employeeId) {
                <div class="suggestion-item" (click)="addPreferred(r.resource)">
                  <div class="resource-info">
                    <span class="resource-name">{{ r.resource.fullName }}</span>
                    <span class="resource-role">{{ r.subtitle }}</span>
                  </div>
                </div>
              }
            </div>
          </div>
        } @else if (
          preferredNotFound &&
          (form.get("preferredSearch")?.value || "").trim().length >= 3
        ) {
          <div class="preferred-suggestions">
            <div class="suggestion-item no-results">
              <div class="resource-info">
                <span class="no-results-text">No search results</span>
              </div>
            </div>
          </div>
        }
      </div>

      <div class="selected-chips-panel">
        @if (preferred.length > 0) {
          @for (p of preferred; track p.id) {
            <div class="selected-chip">
              <span class="chip-text">
                <span class="chip-label">{{ p.name }}</span>
                <span class="chip-sub">{{ p.role }}</span>
              </span>
              <button
                mat-icon-button
                type="button"
                class="remove-button"
                (click)="removePreferred(p.id)"
                title="Remove resource"
              >
                <mat-icon class="remove-icon">remove_circle</mat-icon>
              </button>
            </div>
          }
        } @else {
          <span class="selected-chips-placeholder">
            No preferred resources added yet
          </span>
        }
      </div>
    </div>
  </div>
</form>
